<template>
  <v-container>
    <v-row class="d-flex">
      <v-col
        cols="12"
        sm="6"
        md="4"
        lg="3"
        xl="3"
        v-for="project in projects"
        :key="project._id"
      >
        <v-card height="220px" outlined class="d-flex flex-column">
          <v-fab-transition>
            <v-btn
              color="red"
              fab
              dark
              small
              absolute
              top
              right
              @click="deleteProject(project._id, project.name)"
              ><v-hover v-slot="{ hover }">
                <v-icon>{{
                hover ? "mdi-delete" : "mdi-delete-outline"
              }}</v-icon>
            </v-hover>
            </v-btn>
            </v-fab-transition>
            <v-card-title
            style="cursor:pointer"
            @click="$router.push(`/projects/${project._id}/skills`)"
            >
            <h3 class="project-title headline text-capitalize">
            {{ project.name }}
            </h3>
          </v-card-title>
          <v-card-text
            style="cursor:pointer"
            @click="$router.push(`/projects/${project._id}/skills`)"
          >
            <p class="project-description">{{ project.description }}</p>
          </v-card-text>
          <v-spacer></v-spacer>
          <v-card-actions>
            <v-spacer></v-spacer>
             <v-btn
              @click="
                dupliquerProjectDialog = true;
                dupliquerproject = Object.assign({}, project);
              "
              outlined
              rounded
              text
            >
              copy
            </v-btn>
            <v-btn
              @click="
                editProjectDialog = true;
                editproject = Object.assign({}, project);
              "
              outlined
              rounded
              text
            >
              edit
            </v-btn>
            <!-- <v-btn
              @click="
                dupliquerProjectDialog = true;
                dupliquerproject = Object.assign({}, project);
              "
              outlined
              rounded
              text
            >
            Duplicate
            </v-btn> -->
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3" xl="3">
        <v-card
          class="mx-auto d-flex justify-center align-center"
          height="220px"
          @click="addProjectDialog = true"
          outlined
        >
          <v-icon style="font-size:60px">mdi-plus</v-icon>
        </v-card>
      </v-col>

      <v-dialog v-model="addProjectDialog" width="500">
        <v-card>
          <v-card-title>
            <span class="headline">Create Dialog</span>
          </v-card-title>
          <v-card-text>
            <v-text-field
              label="Dialog Name"
              v-model="project.name"
            ></v-text-field>
            <v-textarea
              label="Dialog Description"
              v-model="project.description"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="addProjectDialog = false"
              >Close</v-btn
            >
            <v-btn
              color="blue darken-1"
              :disabled="!project.name"
              text
              @click="createProject"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="editProjectDialog" width="500">
        <v-card>
          <v-card-title>
            <span class="headline">Edit Dialog</span>
          </v-card-title>
          <v-card-text>
            <v-text-field
              label="Dialog Name"
              v-model="editproject.name"
            ></v-text-field>
            <v-textarea
              label="Dialog Description"
              v-model="editproject.description"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="editProjectDialog = false"
              >Close</v-btn
            >
            <v-btn color="blue darken-1" text @click="editProject">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dupliquerProjectDialog" width="500">
        <v-card>
          <v-card-title>
            <span class="headline">Duplicate Dialog</span>
          </v-card-title>
          <v-card-text>
            <v-text-field
              label="Dialog Name"
              v-model="dupliquerproject.name"
            ></v-text-field>
            <v-textarea label="Dialog Description" v-model="dupliquerproject.description"></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="dupliquerProjectDialog = false"
              >Close</v-btn
            >
            <v-btn color="blue darken-1" text @click="dupliquer"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="importModal" width="500">
        <v-card>
          <div class="px-4 pt-3">
            <!--Hide original input button-->
            <input
              type="file"
              @change="onFileChange"
              ref="fileInput"
              style="display: none"
            />

            <!-- Custom button-->
            <v-btn @click="selectFile">Choose a JSON file</v-btn>
            <span class="ml-5">{{ selectedFileName }}</span>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="blue darken-1" @click="importBot()"
              >import</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row class="align-bottom-column">
      <!-- Bouton export -->
      <v-btn
        fab
        dark
        color="primary"
        class="mb-2"
        @click="importModal = true"
      >
        <v-icon>mdi-upload</v-icon>
      </v-btn>

      <!-- Bouton deconnect -->
      <v-btn
        fab
        dark
        color="gray"
        @click="toDeconnect()"
      >
        <v-icon>mdi-exit-to-app</v-icon>
      </v-btn>
    </v-row>

    <v-dialog
        v-model="showDialog"
        max-width="400"
        persistent
    >
      <v-card
          prepend-icon="mdi-map-marker"
          text="Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running."
          title="Use Google's location service?"
      >
        <v-card-title>
          <span class="headline">Confirmez-vous</span>
        </v-card-title>
        <v-card-text>
          <p>Êtes-vous sûr de vouloir vous déconnecter ? </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="showDialog=false">Non</v-btn>
          <v-btn color="blue darken-1" text @click="confirm()">Oui</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>
<script>
import authMixin from '../mixins/authMixins';

export default {
  data() {
    return {
      project: {},
      editproject: { name: "", description: "" },
      dupliquerproject: { name: "", description: "" },
      projects: [],
      addProjectDialog: false,
      editProjectDialog: false,
      dupliquerProjectDialog: false,
      importModal: false,
      bot: "",
      selectedFileName: "No file selected",
      showDialog: false,
    };
  },
  methods: {
    toDeconnect() {
      this.showDialog = !this.showDialog;
    },

    confirm() {
      localStorage.removeItem('authToken')
      this.showDialog = false
      this.$router.push({name:'Login'})
    },

    importBot() {
      this.$confirm(
          "Import a bot will remove all your data and you can't restore it, Do you really want to Import?"
      ).then((res) => {
        this.$http
            .post(`/projects/import`, { bot: this.bot })
            .then(({ data }) => {
              this.getProject().then(() => {
                this.$notify({
                  type: "success",
                  text: "Dialog Uploded successfully",
                });
                this.importModal = false;
                this.bot = "";
                this.editProjectDialog = false;
                this.editproject = { name: "", description: "" };
              });
            })
            .catch((err) => {
              this.importModal = false;
              this.bot = "";
              this.$notify({ type: "error", text: err.response.data.message });
            });
      });
    },
    editProject() {
      this.$http
          .put(`/projects/${this.editproject._id}`, this.editproject)
          .then(() => {
            this.getProject().then(() => {
              this.editProjectDialog = false;
              this.editproject = { name: "", description: "" };
            });
          })
          .catch((err) => {
            this.$notify({ type: "error", text: err.response.data.message });
          });
    },
    generateObjectId() {
      const timestamp = Math.floor(new Date().getTime() / 1000).toString(16);
      const machineId = Math.floor(Math.random() * 16777216)
          .toString(16)
          .padStart(6, "0");
      const processId = process.pid.toString(16).padStart(4, "0");
      const counter = Math.floor(Math.random() * 16777216)
          .toString(16)
          .padStart(6, "0");

      return timestamp + machineId + processId + counter;
    },
    // async dupliquerProject() {
    //   // Generate a new ObjectId
    //   const objectId = this.generateObjectId();
    //
    //   await this.$http
    //     .get(`/projects/export/${this.dupliquerproject._id}`)
    //     .then(({ data }) => {
    //       data.project._id = objectId;
    //       data.project.name = data.project.name + "-COPY";
    //       return JSON.stringify(data);
    //     })
    //     .then((bot) => {
    //       this.$http
    //         .post(`/projects/import`, { bot: bot })
    //         .then(({ data }) => {
    //           this.getProject().then(() => {
    //             this.$notify({
    //               type: "success",
    //               text: "Dialog dupliquated successfully",
    //             });
    //             this.importModal = false;
    //             this.dupliquerProjectDialog = false;
    //             this.dupliquateproject = { name: "", description: "" };
    //           });
    //         })
    //         .catch((err) => {
    //           this.importModal = false;
    //           this.bot = "";
    //           this.$notify({ type: "error", text: err.response.data.message });
    //         });
    //     });
    // },
    async dupliquer()  {
      if (!this.dupliquerproject.name.trim()) {
        this.$notify({ type: "error", text: "Name is required" });
        return;
      }
      let payload = {
        title: this.dupliquerproject.name,
        description: this.dupliquerproject.description
      }
      await this.$http
          .post(`/projects/duplicate/${this.dupliquerproject._id}`, payload)
          .then(({ data }) => {
            this.getProject().then(() => {
              this.$notify({
                type: "success",
                text: "Dialog dupliquated successfully",
              });
              this.importModal = false;
              this.dupliquerProjectDialog = false;
              this.dupliquateproject = { name: "", description: "" };
            });
          })
          .catch((err) => {
            this.importModal = false;
            this.bot = "";
            this.$notify({ type: "error", text: err.response.data.message });
          });
    },

    createProject() {
      this.$http
          .post(`/projects`, this.project)
          .then(() => {
            this.getProject().then(() => {
              this.project = {};
              this.addProjectDialog = false;
            });
          })
          .catch((err) => {
            this.$notify({ type: "error", text: err.response.data.message });
          });
    },
    deleteProject(id, name) {
      this.$confirm(
          `Are you sure you want to delete the project <strong>${name}</strong> ?`
      ).then((res) => {
        if (res) {
          this.$http
              .delete(`/projects/${id}`)
              .then(() => {
                this.getProject().then(() => {});
              })
              .catch((err) => {
                this.$notify({ type: "error", text: err.response.data.message });
              });
        }
      });
    },
    getProject() {
      return this.$http.get(`/projects`).then(({ data }) => {
        this.projects = data;
      });
    },
    onFileChange(event) {
      const file = event.target.files[0];

      if (!file) {
        this.selectedFileName = "Aucun fichier sélectionné";
        this.$notify({ type: "error", text: "No file selected." });
        return;
      }

      this.selectedFileName = file.name; // Ajout de cette ligne pour afficher le nom du fichier sélectionné

      // Check if it's a .txt file
      if (file.name.slice(-5) !== ".json") {
        this.$notify({ type: "error", text: "Please select a .json file." });
        return;
      }

      // Check file size (10 Mo = 10 * 1024 * 1024 bytes)
      if (file.size > 10 * 1024 * 1024) {
        this.$notify({
          type: "error",
          text: "File size should be less than 10MB.",
        });
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        this.bot = e.target.result;
      };
      reader.readAsText(file);
    },
    selectFile() {
      this.$refs.fileInput.click();
    },
  },

  async beforeMount() {
    await authMixin.methods.checkToken(this.$http, this.$router, { name: 'Home' });
    this.getProject();
  },
};
</script>
<style lang="scss" scoped>
.project-description {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* number of lines to show */
  -webkit-box-orient: vertical;
}
.project-title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  -webkit-box-orient: vertical;
}

.align-bottom-column {
  position: fixed;
  bottom: 0;
  right: 27px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 20px; /* Ajustez l'espace par rapport au bas de la fenêtre */
}
</style>
